import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  clearFiltersButton: {
    display: 'flex',
    marginTop: 8,
    fontSize: 13,
    color: theme.palette.secondary.main,
  },
  filterOptions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  filterPopover: {
    padding: 6,
    borderRadius: 10,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.4)}`,
    overflow: 'hidden',
  },
  filterChips: {
    display: 'flex',
    flexDirection: 'column',
    margin: '4px 10px 4px 4px',
  },
  chipsItself: {
    margin: '5px 0',
  },
}));
